import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { SavedRepliesPageLayout } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPage'
import { EditSaveReplyContent } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/EditSaveReplyContent/EditSaveReplyContent'
import { SavedRepliesRoutes } from './type'

export const SavedRepliesRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<SavedRepliesPageLayout />}>
        <Route index element={<EditSaveReplyContent />} />
        <Route path={`${SavedRepliesRoutes.create}`} element={<EditSaveReplyContent />} />
      </Route>
    </RoutesWithNotFound>
  )
})
